import { Nullable } from 'legacy/lut/classes/models/utils'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Controller } from 'core-components/library/validation'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { deleteQBRSettingsVersion } from 'partner360/features/QBR'
import { IQBRPartner } from 'partner360/models/qbr/IQBRPartners'

import styles from './QbrDeletePartnerFromDocumentDialog.module.scss'

interface IQbrDeletePartnerFromDocumentContentProps {
  selectedPartner: Nullable<IQBRPartner>
  closeDialog: () => void
  qbrSettingsData: IQBRPartner[]
}

export const QbrDeletePartnerFromDocumentContent = ({
  selectedPartner,
  closeDialog,
}: IQbrDeletePartnerFromDocumentContentProps) => {
  const [wip, setWip] = useState(false)
  const dispatch = useAppDispatch()

  const partnerIdValue = selectedPartner?.PartnerID ? selectedPartner.PartnerID : ''

  const onDelete = useCallback(async () => {
    setWip(true)
    dispatch(deleteQBRSettingsVersion(partnerIdValue))
    setWip(false)
    closeDialog()
  }, [partnerIdValue, closeDialog, dispatch])

  return (
    <Controller>
      <div className={styles.root}>
        <LoaderOverlay isVisible={wip} />
        <div className={styles.title}>
          <Translation text={TRANSLATION_KEYS.buttons.deletePartnerFromDocument} />
        </div>
        <div className={styles.btnWrapper}>
          <Button onClick={onDelete}>
            <Translation text={TRANSLATION_KEYS.buttons.deleteRecordButton} />
          </Button>
        </div>
      </div>
    </Controller>
  )
}
